module.exports = __webpack_public_path__ + "775ee4c5d0591e688ad18e09aa72b5e4.svg";